import { RootState } from '@app/store/types';

/**
 * 열람되어 있는 전체 모달 상태를 반환한다.
 */
export const getActiveModals = (state: RootState) => state.modal;

/**
 * 열람되어 있는 모달 개수를 반환한다.
 */
export const getActiveModalCount = (state: RootState): number => getActiveModals(state).length;
